import { render, staticRenderFns } from "./Atomium.vue?vue&type=template&id=15788d64&scoped=true&"
import script from "./Atomium.vue?vue&type=script&lang=js&"
export * from "./Atomium.vue?vue&type=script&lang=js&"
import style0 from "./Atomium.vue?vue&type=style&index=0&id=15788d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15788d64",
  null
  
)

export default component.exports